<template>
    <div
      class="overflow-hidden absolute top-16 left-0 mt-2 min-w-[280px] bg-white dark:bg-[#8542b41d] border border-[#9857c81A] !backdrop-blur-xl rounded-xl shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50"
    >
      <!-- Arrow -->
      <!-- <div class="absolute -top-2 left-4 w-3 h-3 bg-white  rotate-45 shadow-sm"></div> -->

      <!-- Items -->
      <NuxtLink
        v-for="(item, i) in items"
        :key="i"
        :to="item.link"
        :class="lastLink ? 'last:border-t border-[#F0E5FF] dark:border-[#FFFFFF1A] last:py-4' : ''"
        class="font-normal block px-4 py-3 text-sm text-gray-800 dark:text-white/80 hover:bg-gray-100 dark:hover:bg-[#ffffff0d] transition"
      >
        {{ item.label }}
      </NuxtLink>
    </div>
</template>

<script setup>
defineProps({
  label: String,
  items: Array,
  lastLink: Boolean,
});
</script>